import { Link } from 'react-router';
import { Logo } from '../../shared/ui/components';
import '../landing/landing.css';

/** Versión vigente de los Términos y Condiciones (queda en la bitácora al registrar cada Iglesia). */
export const TERMS_VERSION = '2026-10-25';
const CONTACT = 'privacidad@mykeora.com';

/** Términos y Condiciones del servicio KEORA para las iglesias que lo contratan. */
export function TermsPage() {
  return (
    <div className="landing">
      <header className="landing__bar">
        <Link to="/" aria-label="Inicio">
          <Logo />
        </Link>
      </header>
      <main className="legal">
        <h1>Términos y Condiciones del Servicio</h1>
        <p className="muted">Última actualización: 25 de octubre de 2026</p>

        <p>
          Estos Términos y Condiciones regulan el uso de <strong>KEORA</strong> (mykeora.com), plataforma en línea para la administración, comunicación y vida
          de las iglesias, por parte de las iglesias que la contratan. Léelos con atención: al registrar una iglesia, pagar una suscripción o seguir usando
          KEORA, la iglesia los acepta en su totalidad.
        </p>

        <h2>1. Quién presta el servicio</h2>
        <p>
          El servicio lo presta <strong>KEORA</strong>, con sede en Ciudad Juárez, Chihuahua, México («KEORA», «nosotros»). Para cualquier asunto relacionado
          con estos términos, escríbenos a <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.
        </p>

        <h2>2. Definiciones</h2>
        <ul>
          <li>
            <strong>Iglesia:</strong> la iglesia, congregación, misión u organización religiosa que se registra en KEORA y contrata el servicio.
          </li>
          <li>
            <strong>Administrador:</strong> la persona que registra a la Iglesia y cualquier otra a quien la Iglesia le dé permisos de administración.
          </li>
          <li>
            <strong>Usuarios:</strong> los miembros, visitantes, servidores y demás personas que usan KEORA dentro de la Iglesia.
          </li>
          <li>
            <strong>Plan:</strong> el paquete de funciones, capacidad (por ejemplo, número de miembros) y precio que la Iglesia elige.
          </li>
          <li>
            <strong>Periodo:</strong> el tiempo que cubre cada pago (mensual, trimestral, semestral o anual, según lo que ofrezca el Plan).
          </li>
        </ul>

        <h2>3. Aceptación y quién puede contratar</h2>
        <p>
          Quien registra a la Iglesia declara que es mayor de edad, que tiene autorización de la Iglesia para contratar en su nombre y que la información que
          proporciona es verdadera. Si no estás de acuerdo con estos términos, no registres la iglesia ni uses el servicio. Además de estos términos, el uso de
          KEORA se rige por nuestro <Link to="/privacidad">Aviso de Privacidad</Link>.
        </p>

        <h2>4. El servicio</h2>
        <p>
          KEORA es un servicio en línea que se presta «como está» y se mejora de forma continua. Podemos agregar, cambiar o retirar funciones, siempre buscando
          que la Iglesia conserve el acceso a su información. Las funciones disponibles dependen del Plan contratado. Algunas herramientas propias de una
          denominación o concilio solo se activan cuando KEORA verifica que la Iglesia pertenece a ella.
        </p>
        <p>
          El contenido que KEORA publica para todas las iglesias (por ejemplo, lecciones, devocionales y estudios) se redacta conforme a las 16 Verdades
          Fundamentales de las Asambleas de Dios.
        </p>

        <h2>5. Cuenta y seguridad</h2>
        <ul>
          <li>Para registrar una iglesia es necesario confirmar el correo de la cuenta.</li>
          <li>
            La Iglesia es responsable de a quién da permisos dentro de KEORA, de mantener sus contraseñas en secreto y de todo lo que se haga con las cuentas de
            sus Administradores.
          </li>
          <li>Si sospechas de un acceso indebido, avísanos de inmediato.</li>
        </ul>

        <h2>6. Prueba gratuita</h2>
        <p>
          Al registrarse, la Iglesia recibe una prueba limitada y sin costo de <strong>15 días</strong> (o la que indique el Plan). La prueba no genera ningún
          cobro. Al terminar, para seguir modificando información la Iglesia debe pagar el Plan; si no lo hace, la cuenta queda en solo lectura (ver sección
          10). KEORA puede ofrecer la prueba, cambiar su duración o activar iglesias nuevas solo después de revisarlas o de recibir su primer pago.
        </p>

        <h2>7. Planes, precios y forma de pago</h2>
        <ul>
          <li>
            Los precios están en <strong>pesos mexicanos (MXN)</strong> e incluyen los impuestos que correspondan, salvo que el precio indique otra cosa.
          </li>
          <li>
            Cada Periodo se paga <strong>por adelantado</strong>. El pago se hace a través de Mercado Pago o Stripe; KEORA <strong>no ve ni guarda</strong> los
            datos de tarjetas. Las condiciones de esos proveedores también aplican al pago.
          </li>
          <li>
            Cuando la Iglesia autoriza el <strong>cargo automático</strong>, acepta que se le cobre al inicio de cada Periodo el precio vigente, sin necesidad de
            una autorización nueva cada vez, hasta que lo cancele.
          </li>
          <li>
            El precio final se compone del Plan, los extras que la Iglesia agregue (por ejemplo, miembros adicionales) y, en su caso, los descuentos o
            cortesías vigentes. Los descuentos y cortesías duran solo el tiempo indicado.
          </li>
          <li>
            Si la Iglesia supera la capacidad de su Plan, no podrá agregar más miembros hasta cambiar de Plan o contratar extras.
          </li>
        </ul>

        <h2>8. El precio puede variar de un periodo a otro</h2>
        <p>
          <strong>
            La Iglesia reconoce y acepta que el costo de la mensualidad (o del Periodo que elija) puede variar de un Periodo a otro, incluso de un mes al
            siguiente.
          </strong>{' '}
          El precio puede cambiar, entre otras razones, por ajustes de tarifas de KEORA, por cambios en los costos del servicio, por inflación, por el número de
          miembros o extras de la Iglesia, por un cambio de Plan o porque termina un descuento o una cortesía.
        </p>
        <ul>
          <li>El precio que se cobra en cada Periodo es el que aparece en la sección Facturación de KEORA al momento del cobro.</li>
          <li>Un cambio de precio nunca modifica un Periodo que ya está pagado: aplica a partir del siguiente.</li>
          <li>
            Cuando KEORA cambie sus tarifas, lo publicará en Facturación y, cuando sea posible, avisará a los Administradores por correo o dentro de la app antes
            del cobro en que aplique.
          </li>
          <li>
            Si la Iglesia no está de acuerdo con el nuevo precio, puede cancelar antes del siguiente cobro. Pagar o seguir usando el servicio después del cambio
            significa que acepta el nuevo precio.
          </li>
        </ul>

        <h2>9. No hay reembolsos</h2>
        <p>
          <strong>Todos los pagos son definitivos y no son reembolsables.</strong> No se devuelve total ni parcialmente lo pagado, entre otros casos, cuando:
        </p>
        <ul>
          <li>la Iglesia cancela antes de que termine el Periodo pagado;</li>
          <li>la Iglesia no usa el servicio o lo usa solo una parte del Periodo;</li>
          <li>la Iglesia cambia a un Plan de menor precio o quita extras;</li>
          <li>se pagó un Periodo largo (trimestral, semestral o anual) y la Iglesia deja de usarlo antes;</li>
          <li>la cuenta se suspende o se da por terminada por incumplir estos términos.</li>
        </ul>
        <p>
          La única excepción son los <strong>cobros duplicados o hechos por error</strong> atribuibles a KEORA o al proveedor de pagos: si la Iglesia los reporta
          dentro de los 30 días siguientes al cargo, los corregiremos con una devolución o con un saldo a favor. Si la Iglesia inicia un contracargo o
          desconocimiento de un cargo que sí corresponde, KEORA puede suspender la cuenta mientras se aclara.
        </p>

        <h2>10. Falta de pago y cuenta en solo lectura</h2>
        <ul>
          <li>Si un Periodo pagado vence, la Iglesia tiene <strong>7 días de gracia</strong> en los que todo sigue funcionando.</li>
          <li>
            Si termina la gracia (o la prueba) sin pago, la cuenta queda en <strong>solo lectura</strong>: la Iglesia y sus Usuarios pueden consultar su
            información, pero no modificarla. La página pública de la Iglesia sigue activa y la sección Facturación siempre está disponible para pagar.
          </li>
          <li>Al pagar, la cuenta se reactiva con toda su información.</li>
          <li>Los días que la cuenta estuvo en solo lectura no se descuentan ni se compensan.</li>
        </ul>

        <h2>11. Cancelación y terminación</h2>
        <ul>
          <li>
            La Iglesia puede cancelar su suscripción en cualquier momento: basta con no pagar el siguiente Periodo (y desactivar el cargo automático, si lo
            tiene) o escribirnos a <a href={`mailto:${CONTACT}`}>{CONTACT}</a>. El servicio sigue funcionando hasta que termine el Periodo pagado y después la
            cuenta queda en solo lectura, sin reembolso (sección 9).
          </li>
          <li>
            KEORA puede suspender o dar por terminado el servicio de una Iglesia que incumpla estos términos, que use KEORA para fines ilícitos o que ponga en
            riesgo a otros usuarios o a la plataforma. Cuando sea razonable, avisaremos antes.
          </li>
          <li>
            Si KEORA decidiera dejar de prestar el servicio en general, lo avisará con al menos 30 días de anticipación para que la Iglesia pueda pedir una copia
            de su información.
          </li>
        </ul>

        <h2>12. La información es de la Iglesia</h2>
        <ul>
          <li>
            <strong>La Iglesia es dueña de la información que registra</strong> (miembros, familias, asistencia, ministerios, finanzas, contenido, etc.). KEORA
            la guarda y la procesa solo para prestar el servicio, por cuenta de la Iglesia, como se explica en el{' '}
            <Link to="/privacidad">Aviso de Privacidad</Link>. No la vendemos ni la rentamos.
          </li>
          <li>
            La Iglesia es responsable de contar con el consentimiento de las personas cuyos datos registra, en especial de los datos de niñas, niños y
            adolescentes y de los datos sensibles (creencias religiosas, consejería, peticiones de oración).
          </li>
          <li>
            La Iglesia puede pedir una copia de su información o su eliminación escribiendo a <a href={`mailto:${CONTACT}`}>{CONTACT}</a> desde el correo de un
            Administrador. Al eliminarla, KEORA solo conservará lo que la ley le obligue a guardar.
          </li>
          <li>Cada iglesia solo ve su propia información; la separación entre iglesias es estricta.</li>
        </ul>

        <h2>13. Acceso del personal de KEORA</h2>
        <p>
          Para dar soporte, verificar iglesias, resolver problemas, proteger la plataforma o cumplir la ley, la administración de KEORA puede consultar la
          información de la Iglesia. <strong>Cada uno de esos accesos queda registrado</strong> en una bitácora de seguridad, y el personal de KEORA está
          obligado a guardar confidencialidad.
        </p>

        <h2>14. Uso aceptable</h2>
        <p>La Iglesia y sus Usuarios se comprometen a no:</p>
        <ul>
          <li>usar KEORA para actividades ilícitas, fraudes o para dañar a otras personas;</li>
          <li>publicar contenido que infrinja derechos de autor, marcas o la privacidad de terceros;</li>
          <li>enviar mensajes masivos no deseados (spam) ni suplantar a otra persona o iglesia;</li>
          <li>intentar entrar a información de otras iglesias, vulnerar la seguridad o sobrecargar la plataforma;</li>
          <li>copiar, revender, sublicenciar o hacer ingeniería inversa de KEORA.</li>
        </ul>

        <h2>15. Contenido que publica la Iglesia</h2>
        <p>
          La Iglesia es responsable del contenido que sube o publica en KEORA (textos, imágenes, videos, cantos, predicaciones, etc.) y de contar con las
          licencias necesarias para usarlo, por ejemplo, las licencias de cantos o de versiones de la Biblia que no estén incluidas en KEORA. La Iglesia le
          permite a KEORA guardar, procesar y mostrar ese contenido solo para prestarle el servicio. KEORA puede retirar contenido que viole la ley o estos
          términos.
        </p>

        <h2>16. Propiedad intelectual de KEORA</h2>
        <p>
          El software, el diseño, la marca KEORA, sus logotipos y el contenido propio de la plataforma son propiedad de KEORA o de sus licenciantes. La
          suscripción le da a la Iglesia un derecho de uso personal, no exclusivo e intransferible mientras esté vigente; no le transfiere ninguna propiedad.
        </p>

        <h2>17. Disponibilidad y respaldos</h2>
        <p>
          Hacemos nuestro mejor esfuerzo para que KEORA esté disponible todo el tiempo y respaldamos la información todos los días, pero no garantizamos que el
          servicio funcione sin interrupciones ni errores. Puede haber pausas por mantenimiento, por actualizaciones o por fallas de proveedores (internet,
          alojamiento, correo, pagos) ajenas a KEORA.
        </p>

        <h2>18. Limitación de responsabilidad</h2>
        <p>
          En la medida que lo permita la ley, KEORA no responde por daños indirectos, pérdida de ingresos, donativos u oportunidades, ni por fallas de servicios
          de terceros. La responsabilidad total de KEORA frente a la Iglesia por cualquier reclamación se limita a lo que la Iglesia haya pagado a KEORA en los
          3 meses anteriores al hecho que la origina.
        </p>

        <h2>19. Cambios a estos términos</h2>
        <p>
          Podemos actualizar estos términos. Publicaremos la versión nueva en esta página (mykeora.com/terminos) con su fecha y, si el cambio es importante,
          avisaremos a los Administradores en la app o por correo. Seguir usando KEORA después del cambio significa que la Iglesia acepta la versión nueva.
        </p>

        <h2>20. Avisos</h2>
        <p>
          Los avisos de KEORA a la Iglesia se envían al correo de sus Administradores o se muestran dentro de la app. Los avisos de la Iglesia a KEORA se
          envían a <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.
        </p>

        <h2>21. Ley aplicable y jurisdicción</h2>
        <p>
          Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier controversia, las partes se someten a los tribunales
          competentes de Ciudad Juárez, Chihuahua, y renuncian a cualquier otro fuero que pudiera corresponderles por su domicilio presente o futuro.
        </p>

        <p className="legal__back">
          <Link to="/">← Volver a KEORA</Link>
        </p>
      </main>
      <footer className="landing__footer">
        <span>© KEORA</span> · <Link to="/privacidad">Aviso de privacidad</Link>
      </footer>
    </div>
  );
}
